export const useDocumentEvaluativeParagraphsStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentEvaluativeParagraphs(documentId, revision.id)();
};
